import React, { useEffect, useState } from 'react';
import { Box, Collapse, Grid } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import ConsentSelector from '~/components/BillingEligibility/ConsentSelector';
import { CcmNoConsentLayout, CcmOptInLayout, CcmOptOutLayout } from "~/components/consent/CcmConsentLayouts";
import { ConsentHelpIcon } from './ConsentHelpIcon';
import { CptCodeChip } from './CptCodeChip';
export const CcmConsentSection = (props) => {
    const { patient, consentMethod, consentDate, consentNotes, optOutReason, optOutDate, optOutNotes } = props;
    const [isOpen, setIsOpen] = useState(false);
    const [selection, setSelection] = useState('');
    const [ccmFormData, setCcmFormData] = useState(null);
    useEffect(() => {
        let initialSelection = '';
        if (patient.ccmConsent) {
            initialSelection = 'opt-in';
        }
        if (!patient.ccmConsent && patient.ccmConsentedAt !== null) {
            initialSelection = 'opt-out';
        }
        if (!patient.ccmConsent && (patient.ccmConsentedAt === null || patient.ccmConsentedAt === '')) {
            initialSelection = 'no-consent';
        }
        setSelection(initialSelection);
        props.onCcmDataChange(initialSelection, null);
    }, []);
    const handleSelectionChange = (newSelection) => {
        setSelection(newSelection);
        props.onCcmDataChange(newSelection, ccmFormData);
    };
    const handleFormDataChange = (data) => {
        setCcmFormData(data);
        // Notify parent of form data change
        props.onCcmDataChange(selection, data);
    };
    return (React.createElement(Box, { sx: { marginBottom: 2 } },
        React.createElement(Box, { sx: {
                backgroundColor: '#F5F5F5',
                padding: '12px 16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                cursor: 'pointer',
                borderRadius: isOpen ? '8px 8px 0 0' : '8px',
                transition: 'border-radius 0.2s ease',
            } },
            React.createElement(Grid, { container: true },
                React.createElement(Grid, { item: true, xs: 8, sx: { display: 'block', alignItems: 'left', gap: 1 }, onClick: () => setIsOpen(!isOpen) },
                    React.createElement("div", { className: 'flex' },
                        React.createElement(ExpandMore, { sx: {
                                transform: isOpen ? 'rotate(0deg)' : 'rotate(-90deg)',
                                transition: 'transform 0.2s ease',
                                color: isOpen ? '#4CAF50' : '#0000008F',
                            } }),
                        React.createElement(Box, { sx: {
                                fontFamily: 'Barlow',
                                fontSize: '16px',
                                fontWeight: 500,
                                color: '#1F2937',
                                display: 'flex'
                            } },
                            "Chronic Care Management (CCM) ",
                            React.createElement(ConsentHelpIcon, { program: 'CCM' }))),
                    React.createElement("div", { className: 'flex gap-2' },
                        React.createElement(CptCodeChip, { code: '99490' }),
                        React.createElement(CptCodeChip, { code: '99439' }),
                        React.createElement(CptCodeChip, { code: '99487' }),
                        React.createElement(CptCodeChip, { code: '99489' }))),
                React.createElement(Grid, { item: true, xs: 4, style: { marginTop: 'auto', marginBottom: 'auto' } },
                    React.createElement(ConsentSelector, { onSelectionChange: handleSelectionChange, selectedValue: selection })))),
        React.createElement(Collapse, { in: isOpen },
            React.createElement(Box, { sx: {
                    border: '1px solid #E5E7EB',
                    borderTop: 'none',
                    borderRadius: '0 0 8px 8px',
                    padding: '16px',
                    backgroundColor: 'white',
                } },
                React.createElement(Box, { sx: { color: '#666', fontSize: '14px' } },
                    selection === 'no-consent' && React.createElement(CcmNoConsentLayout, null),
                    selection === 'opt-in' &&
                        React.createElement(CcmOptInLayout, { patient: patient, allRequiredChecks: props.onCcmRequiredChecks, optIn: patient.ccmConsent, consentMethod: consentMethod, consentDate: consentDate, consentNotes: consentNotes, onFormDataChange: handleFormDataChange }),
                    selection === 'opt-out' &&
                        React.createElement(CcmOptOutLayout, { optOut: (!patient.ccmConsent && (patient.ccmConsentedAt !== null && patient.ccmConsentedAt !== '')), isNoConsent: !patient.ccmConsent && (patient.ccmConsentedAt === null || patient.ccmConsentedAt === ''), patient: patient, allRequiredChecks: props.onCcmRequiredChecks, optOutReason: optOutReason, optOutDate: optOutDate, optOutNotes: optOutNotes, onFormDataChange: handleFormDataChange }))))));
};
